// This icon file is generated automatically.
var UpFilled = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 24 24", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M12.77 8.36a1 1 0 00-1.54 0l-5 6A1 1 0 007 16h10a1 1 0 00.77-1.64l-5-6z" } }] }, "name": "up", "theme": "filled" };
export default UpFilled;
